import { css as i } from "@microsoft/fast-element";
import { display as l } from "@matrix42/fast-foundation";
import { normalize as t } from "../../common/normalize.js";
import { designTokens as o } from "../../design-tokens.js";
const s = i`
  ${t}
  ${l("table-cell")}
  :host {
    /* Layout */
    padding: ${o.spacing["2.5"]} ${o.spacing[4]};
    vertical-align: middle;
  }
`;
export {
  s as tableCellStyles
};
